const sign = (d) => `Yours sincerely,\n\n${d.sendco || "[SENDCO name]"}\nSENDCO, ${d.school || "[School name]"}`;

export const LETTERS = [
  {
    id: "concern",
    label: "Initial SEND concern meeting",
    build: (d, p, c, when) => `Dear ${p},

I am writing to invite you to a meeting to talk about how ${c} is getting on in school. Some of ${c}'s teachers have noticed that they may benefit from some extra help with their learning, and we would really value your views.

The meeting will be ${when}. It will be an informal conversation and there is nothing you need to prepare, but you may find it helpful to think about:
• what ${c} enjoys and finds easier
• anything ${c} finds difficult, at school or at home
• any questions or worries you have

You are welcome to bring someone with you for support. If the date or time is not convenient, please let me know and we will find another time.

${sign(d)}`,
  },
  {
    id: "review",
    label: "Review meeting invitation",
    build: (d, p, c, when) => `Dear ${p},

As part of our Assess, Plan, Do, Review cycle, I would like to invite you to a meeting to review the support in place for ${c}.

The meeting will be ${when}.

Together we will look at the progress ${c} has made towards their targets, talk about what is working well and what could be better, and agree the next steps. Your knowledge of ${c} is really important, so please bring any thoughts, questions or examples from home.

If you are unable to attend, please contact me so we can arrange another time or a phone call.

${sign(d)}`,
  },
  {
    id: "annual",
    label: "Annual review invitation",
    build: (d, p, c, when) => `Dear ${p},

Your child's Education, Health and Care Plan (EHCP) is due for its annual review. I would like to invite you to the review meeting, which will be ${when}.

Before the meeting we will ask for your views, and for ${c}'s own views, about how things are going. We will also request advice from the professionals who work with ${c} and share it with you at least two weeks before the meeting.

At the meeting we will review progress towards the outcomes in the plan, check that the support is still right, and agree any changes to recommend to the Local Authority.

Please let me know whether you can attend, and if there is anyone else you would like us to invite.

${sign(d)}`,
  },
  {
    id: "summary",
    label: "Follow-up summary letter",
    build: (d, p, c, when) => `Dear ${p},

Thank you for meeting with us ${when} to talk about ${c}. I am writing to confirm what we discussed and agreed.

What is going well:
• [Add points]

What we agreed to focus on:
• [Add points]

Actions:
• School will: [Add actions]
• At home: [Add actions]

Next review date: [Add date]

If anything in this summary does not match your understanding of the meeting, or if you have any questions, please do get in touch.

${sign(d)}`,
  },
  {
    id: "feedback",
    label: "Parent feedback request",
    build: (d, p, c) => `Dear ${p},

We want to make sure that families of children with special educational needs and disabilities feel listened to and well supported at ${d.school || "[School name]"}. We would be grateful if you could spare a few minutes to tell us about your experience.

You might like to tell us:
• what has worked well for ${c}
• anything we could do better
• how easy it is to get information and to contact us

You can reply to this letter, email me, or ask for a short phone call, whichever is easiest for you. Every response is read, and we will share what we have changed as a result.

Thank you for your support.

${sign(d)}`,
  },
];

export const buildLetter = (tpl, d) => {
  const p = d.parent || "[Parent / carer name]";
  const c = "your child";
  const parts = [d.date && `on ${new Date(d.date).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}`, d.time && `at ${d.time}`, d.place && `in ${d.place}`].filter(Boolean);
  const when = parts.length ? parts.join(" ") : "on [date] at [time] in [location]";
  return tpl.build(d, p, c, when);
};
